import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { useIntl } from "react-intl"

import StoryblokBasicImage from "../storyblokBasicImage/StoryblokBasicImage"
import StoryblokLink from "../storyblokLink/StoryblokLink"

import { PlayButtonSVG } from "../../svg"

import * as styles from "./TallCard.module.scss"

function ConditionalClick({ target, link, on_click_handler, link_class, btn_class, children }) {

  if(link) {
    return (
      <StoryblokLink withClass={link_class} SBLinkData={link} newWindow={target === "_blank" ? true : false}>
        {children}
      </StoryblokLink>
    )
  } else {
    return (
      <button onClick={on_click_handler} className={btn_class}>
        {children}
      </button>
    )
  }
}

function TallCard({ thumbnail, type, title, description, cta_label, cta_link, cta_target, show_video_button, video_url }) {
  const intl = useIntl()
  const [shouldShowModal,setShouldShowModal] = useState(false)

  function handleShowModal() {
    setShouldShowModal(true)
  }
  function handleCloseModal() {
    setShouldShowModal(false)
  }

  return (
    <>
      <article className={`panel-radius shadow-cards ${styles.wrapper}`}>
        <div className={styles.image_wrapper}>
          <ConditionalClick target={cta_target} btn_class={styles.clickable} link={video_url ? null : cta_link} on_click_handler={handleShowModal}>
            {thumbnail && thumbnail.filename ? <StoryblokBasicImage image={thumbnail} /> : null}
            {show_video_button ? (
              <div className={styles.playButton}>
                <PlayButtonSVG />
              </div>
            ) : null}
          </ConditionalClick>
        </div>
        <div className={styles.content}>
          {type ? <div className={styles.label}>{type}</div> : null}
          {title ? (
            <ConditionalClick target={cta_target} btn_class={styles.clickable} link_class={styles.clickable} link={video_url ? null : cta_link} on_click_handler={handleShowModal}>
              <div className={styles.title}>{title}</div>
            </ConditionalClick>
          ) : null}
          {description ? <p>{description}</p> : null}
          {cta_label ? (
            <div className={styles.cta}>
              <ConditionalClick target={cta_target} btn_class={styles.clickable+" "+styles.link} link={video_url ? null : cta_link} on_click_handler={handleShowModal}>
                {cta_label}
              </ConditionalClick>
            </div>
          ) : null}
        </div>
      </article>
      {video_url ? (
        <Modal
          className="video-modal"
          size="lg"
          centered
          show={shouldShowModal}
          onHide={handleCloseModal}>
          <Modal.Header>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCloseModal}
            >
              {intl.messages["widget.modal.exit"]}
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="video-wrapper">
              <iframe
                width="920"
                height="518"
                src={video_url}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  )
}

export default TallCard